module.exports = __webpack_public_path__ + "static/media/icon-1-x-l.223d111a.svg";